// extracted by mini-css-extract-plugin
export default {"tag-style-wrap":"AboutUs_tag-style-wrap__tq+FZ","tag-icon-wrap":"AboutUs_tag-icon-wrap__W8oJj"};